const API_BASE = "/api/calendar";

export const fetchUserEvents = async (userId) => {
  const res = await fetch(`${API_BASE}/user_id/${userId}`);
  return res.json();
};

export const createEvent = async (eventData) => {
  const res = await fetch(`${API_BASE}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(eventData),
  });

  const data = res.json();

  return data;
};

export const updateEvent = async (id, updatedData) => {
  const res = await fetch(`${API_BASE}/event/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  });

  const data = res.json();

  return data;
};

export const deleteEvent = async (id) => {
  const res = await fetch(`${API_BASE}/event/${id}`, {
    method: "DELETE",
  });

  const data = res.json();

  return data;
};

export const fetchUpcomingEvents = async (userId) => {
  const res = await fetch(`${API_BASE}/upcoming/${userId}`);
  if (!res.ok) throw new Error("Failed to fetch upcoming appointments");
  return await res.json();
};